import {storeInstance} from '@aofl/store/dist/legacy';
import {products, sdoNs} from '@modules/constants-enumerate';
import {deepAssign} from '@aofl/object-utils';

const sdo = {
  namespace: sdoNs.RESOURCES,
  mutations: {
    init() {
      return {
        selectedProduct: '',
        hasReports: false,
      };
    },
  },
  decorators: [
    (nextState) => { // $products
      const nextSubState = nextState[sdoNs.RESOURCES];
      const state = storeInstance.getState();
      if (typeof nextSubState.$products === 'undefined' ||
        nextState[sdoNs.SESSION].$activeAoflProducts !== state[sdoNs.SESSION].$activeAoflProducts
      ) {
        const $products = [];
        nextState[sdoNs.SESSION].$activeAoflProducts?.map((product) => {
          if (product === products.MY_READING_ACADEMY
              || product === products.MATH_ACADEMY
              || product === products.MY_MATH_ACADEMY) {
            $products.push(product);
          }
        });
        nextState = deepAssign(nextState, sdoNs.RESOURCES, {
          $products
        });
      }
      return nextState;
    },
  ]
};

storeInstance.addState(sdo);
